export const PwcTheme = {
  dark: false,
  colors: {
    // PwC custom colors
    primary: "#ffffff", // white
    secondary: "#D04A02", // orange
    tertiary: "#EB8C00", // tangerine
    quaternary: "#E0301E", // red
    darkGreyButton: "#2d2d2d", // darkgrey
    primaryButton: "#EB8C00", // tertiary
    primarySpinner: "#FFFFFF",

    statusGreen: "#175d2d",
    statusRed: "#e0301e",
    statusYellow: "#ffb600",

    primaryBlue: "#415385",

    fieldOutlineColor: "#FFBF33",
  },
};
